import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { SampleEditSessionUrl } from '../SampleEditSessionUrl';

const deleteSampleDrafts = async ({
  sessionId,
  rowIds,
}: {
  sessionId: string;
  rowIds: number[];
}) =>
  apiClient
    .patch(expand(SampleEditSessionUrl.rows, { sessionId }), {
      drafts: rowIds.map((rowId) => ({ rowId, op: 'DELETE', payload: null })),
    })
    .then((response) => response.data);

export const useDeleteSampleDraftsMutation = createApiMutationHook(
  ['sample-draft-delete'],
  deleteSampleDrafts,
);
